import { Store, SerializedData } from "bernie-core";
import { observable, action } from "mobx";
import { Logger, NOOP_LOGGER } from "bernie-logger";

export class DestinationSuggestionsStore extends Store {
  @observable
  public destinationSuggestionsOrigin?: string;

  public constructor(state: SerializedData = {}, logger: Logger = NOOP_LOGGER) {
    super(state, logger);
  }

  public hydrate(data: SerializedData): void {
    Object.assign(this, data);
    this.setupDestinationSuggestions();
  }

  @action
  public setupDestinationSuggestions() {
    this.destinationSuggestionsOrigin = "";
  }

  @action
  public setOriginForDestinationSuggestions(destinationSuggestionsOrigin?: string) {
    this.destinationSuggestionsOrigin = destinationSuggestionsOrigin;
  }
}
